// 포그라운드로 도착한 푸시 알림을 앱 안에서 토스트로 표시하는 연결 컴포넌트
//
// 알림 리스너 자체는 React 밖(utils/pushHandlers.ts)에서 한 번만 등록된다.
// 훅에 넣으면 App/StudentHome/ParentShell 세 곳에서 중복 등록돼 토스트가 여러 번 뜬다.
// 이 컴포넌트는 ToastProvider 안에서 그 이벤트를 받아 표시하는 역할만 한다.
import { useEffect } from 'react';
import { useToast } from './Toast';
import { PUSH_RECEIVED_EVENT, type PushReceivedDetail } from '../utils/pushHandlers';

const PushToastBridge: React.FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    const handler = (event: Event) => {
      const { title, body } = (event as CustomEvent<PushReceivedDetail>).detail ?? {};
      const message = [title, body].filter(Boolean).join(' — ');
      if (message) showToast(message, 'info');
    };

    window.addEventListener(PUSH_RECEIVED_EVENT, handler);
    return () => window.removeEventListener(PUSH_RECEIVED_EVENT, handler);
  }, [showToast]);

  return null;
};

export default PushToastBridge;
